import { render, staticRenderFns } from "./LeadPage.vue?vue&type=template&id=605a2799&"
import script from "./LeadPage.vue?vue&type=script&lang=js&"
export * from "./LeadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports